import { Record, List } from "immutable"

import type Booking from "../../../../app/scripts/containers/mutable/Booking"
import { TRIPS_LOADING_REQUEST, TRIPS_LOADING_SUCCESS, TRIPS_LOADING_FAILURE } from "./actions"
import { LOGOUT_REQUEST } from "../user/index"

export type TripsReducerType = Record<{
  loading: boolean,
  trips: List<Booking>,
  errors: List<string>,
}>

export const TripsDefaultState = Record({
  trips: null,
  loading: false,
  errors: null,
})

const getFutureTrips = res => new List(res.filter(booking => booking.journey.endsInFuture()))

export default function(state = new TripsDefaultState(), action) {
  switch (action.type) {
    case LOGOUT_REQUEST:
      return new TripsDefaultState()

    case TRIPS_LOADING_REQUEST:
      return state
        .set("trips", null)
        .set("loading", true)
        .set("errors", null)

    case TRIPS_LOADING_SUCCESS:
      return state
        .set("trips", getFutureTrips(action.res))
        .set("loading", false)
        .set("errors", null)

    case TRIPS_LOADING_FAILURE:
      return state
        .set("trips", null)
        .set("loading", false)
        .set("errors", List([action.error.message]))

    default:
      return state
  }
}
